<template>
    <section class="bg-sectionbg cta-wrapper xl:pb-0 md:pb-spc17">
        <div class="container">
            <div class="cta-box text-center xl:p-spc5 md:px-spc7 md:py-10 bg-white relative z-20">
                <div class="cta-content mb-spc12">
                    <p class="xl:text-3xl md:text-size14 font-light text-secondary xl:tracking-spc1 md:tracking-spc2 leading-spc3" :class="descclass">
                        <strong class="xl:text-3xl md:text-size14 font-semibold mb-1" :class="title">{{title}}</strong>
                        {{desc}}</p>
                </div>
                <Button title="Join The Mailing List" url="#" classname="hover:border-secondary hover:bg-secondary" />
            </div>
        </div>
    </section>
</template>

<script>
    import Button from "../common/Button";
    export default {
        name: "CTA",
        components: {Button},
        props: ['title', 'titleclsss', 'descclass', 'desc']
    }
</script>

<style scoped>

</style>